import { render } from "./GrayButton.vue?vue&type=template&id=347717a7&scoped=true"
import script from "./GrayButton.vue?vue&type=script&lang=js"
export * from "./GrayButton.vue?vue&type=script&lang=js"

import "./GrayButton.vue?vue&type=style&index=0&id=347717a7&scoped=true&lang=css"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-347717a7"]])

export default __exports__